import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from 'sushiweb/Button/Button';
import ZImage from 'sushiweb/ZImage/ZImage';
import RightTriangle from 'sushiweb/Icons/all/RightTriangle';
import { AWW_SNAP_IMG } from '../../../../constants/images';
import { genericNotFoundMsg } from '../constants';
import { DataFetchError, Title } from './styles';
import { DASHBOARD_ROUTE } from '../../../../constants/routes';

const NotFound = ({ showAction, actionLabel }) => {
  return (
    <DataFetchError className='center'>
      <ZImage
        src={AWW_SNAP_IMG}
        width='22rem'
        height='21rem'
        fit='contain'
        alt='aww snap'
      />
      <Title>{genericNotFoundMsg}</Title>
      {showAction && (
        <Link to={DASHBOARD_ROUTE}>
          <Button btnColor='red' iconAlign='right' icon={<RightTriangle />}>
            {actionLabel}
          </Button>
        </Link>
      )}
    </DataFetchError>
  );
};

NotFound.propTypes = {
  showAction: PropTypes.bool,
  actionLabel: PropTypes.string,
};

NotFound.defaultProps = {
  showAction: false,
  actionLabel: '',
};

export default NotFound;
